import "./styles.scss";

export default function News({ className }) {
  return (
    <div className={`page-container ${className}`}>
      <div className="news-in">
        <h1>2023 News and Events: Earth Friendly Food Choices</h1>
        <br />
        <p>
          Earthsave Baltimore is a volunteer operated nonprofit whose mission is
          embracing a healthier, sustainable, compassionate and peaceful way of
          eating and living. We hope you will stay in touch and join us for an
          event soon.
        </p>
        <p>
          We host vegan potluck meetings at Govans Presbyterian Church, 5828
          York Road in Baltimore, near Towson. Church is next to the historic
          Senator Theater. The potlucks usually meet on the fourth Saturday of
          each month, from 6:00 until 8:15. Attendees are encouraged to be
          up-to- date with Covid shots.
        </p>
        <br />
        <p>
          Here's on update on our final three events for the year 2023: We have
          upcoming RESTAURANT GATHERINGS on November 12th at 12:30 at the Taj
          Palace in Owings Mills, and on December 10th at 12:30 at Mr. Chan in
          Pikesville. Best way to RSVP is through Baltimore Vegan Meetup
          www.meetup.com/baltimore-vegan/ Or you can contact us at
          Baltimore@Earthsave.org.&nbsp;
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.meetup.com/baltimore-vegan/events"
          >
            RSVP
          </a>
        </p>

        <p>
          We will wrap up the year with our big, annual Thanks-Living
          Celebration. Please share the event with your Facebook friends&nbsp;
          <a target="_blank" rel="noreferrer" href="https://fb.me/e/1ePN1m81o ">
            RSVP and join us if you can!
          </a>
        </p>
        <p>
          Kind Thoughts, Peace, and Gratitude will be the theme for Earthsave
          Baltimore’s Thanks-Living Vegan Open-Mic potluck on Nov. 25th. We’ll
          have live music and entertainment. And attendees will be invited to
          speak briefly from their table or at the front of the room.
          Contact&nbsp;
          <a id="email-underline" href="mailto:https://www.earthsave.org">
            Baltimore@earthsave.org
          </a>{" "}
          if you'd like to reserve a spot onstage.
        </p>
        <p>
          MONTHLY VEGAN POTLUCKS: The attendance fee is $5. Meetup at &nbsp;
          <a
            target="_blank"
            rel="noreferrer"
            href="https://tinyurl.com/ysw34e5h"
          >
            You may RSVP here
          </a>
          , or by email at&nbsp;
          <a id="email-underline" href="mailto:https://www.earthsave.org">
            Baltimore@earthsave.org
          </a>{" "}
          or voicemail 410-252-3043. Share information and connect with
          like-minded local people on Facebook in Earthsave Baltimore
          group&nbsp;
          <a
            target="_blank"
            rel="noreferrer"
            href="  https://tinyurl.com/4bert5hh"
          >
            Baltimore Vegans Facebook
          </a>{" "}
          or{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href="  https://tinyurl.com/4hrajkax"
          >
            Baltimore Vegans
          </a>
        </p>
        <p>
          GUESTS are asked to bring a dish made without animal products that
          will serve 8 or more. If you’d like to bring food just for yourself or
          attend without eating, the fee is $5. We can usually accommodate a few
          guests who wish to attend without bringing a dish. The fee is $20, and
          pre-approval is required. There’s plenty of FREE PARKING. Drive around
          church to large parking lot, where you'll see the white Earthsave
          banner near the Fellowship Hall entry. Please join us when you can!
        </p>
        <p>
          Saturday, Nov. 25th is when Earthsave’s annual THANKS-LIVING VEGAN
          OPEN-MIC POTLUCK will happen. The last open-mic was a blast! We had
          live music, book readings and poetry, stand up comedy and more. We
          invite everyone, vegan or not, who would like to tell a story, sing a
          song, tell a joke, do standup comedy, poetry, magic, or anything your
          imagination would allow. Performers must be approved in advance.
          Contact Don at &nbsp; to be included in the show!
        </p>
        <p>
          You can RSVP and get the latest updates for all Earthsave’s potlucks
          and restaurant gatherings by joining one of these groups: &nbsp;
          <a
            href="https://www.meetup.com/The-Baltimore-Vegan-Meetup-Group/"
            target="_blank"
            rel="noreferrer"
          >
            Baltimore Vegan Meetup
          </a>{" "}
          &nbsp;and&nbsp;
          <a
            href="https://www.meetup.com/vegetarian-9/"
            target="_blank"
            rel="noreferrer"
          >
            Baltimore Vegetarian Meetup
          </a>{" "}
        </p>
        <p>
          Please also join discussions and get event info in the Earthsave
          &nbsp;
          <a
            href="https://www.facebook.com/groups/EarthsaveBaltimore/ "
            target="_blank"
            rel="noreferrer"
          >
            Baltimore Facebook group.
          </a>
        </p>

        <p>
          Saturday. Nov. 18th, 12:00 – 4:00, POPLAR SPRING ANIMAL SANCTUARY in
          Poolesville, MD, will celebrate their annual Thanksgiving WITH the
          Turkeys – join our friendly turkeys and all their friends in
          celebrating a huge cruelty-free Thanksgiving potluck. It’s outdoors,
          so you will want to dress warmly.&nbsp;
          <a href="https://fb.me/e/2wX6BYn2c " target="_blank" rel="noreferrer">
            POPLAR SPRING ANIMAL SANCTUARY THANKSGIVING
          </a>
        </p>
        <p>
          Also, our good friend Chris Dietrich is hosting a game night and
          potluck at his home in Glen Burnie Nov. 18th at 6pm. Call 240 814 4208
          to RSVP.{" "}
        </p>
        <p>
          BALTIMORE VEGANS group on Facebook is a good place to connect with
          like-minded people and learn about local veg/vegan friendly
          restaurants, food sources and events.
          <a
            href="https://www.facebook.com/groups/509056979150170"
            target="_blank"
            rel="noreferrer"
          >
            BALTIMORE VEGANS
          </a>
        </p>
        <p>
          THE WORLD PEACE DIET: Eating for Spiritual Health and Social Harmony,
          is a classic read, an insightful Amazon best-seller by Will Tuttle,
          PhD. The book looks at the far-reaching implications of our food
          choices and offers a set of universal principles for all people of
          conscience that show how we as a species can move our consciousness
          forward.
        </p>

        <br />
        <p>
          DR. MICHAEL GREGER continues to provide easily digested, well
          documented information on nutrition and health, with a focus on whole
          foods, plant-based diets. His site covers a multitude of nutrition
          related health issues. Many of his reports are featured in short and
          often humorous videos. Dr. Greger is a New York Times bestselling
          author of the How Not to Die series books. His newest work, soon to be
          published, is a book on slowing the effects of aging. It’s called “HOW
          NOT TO AGE”. You might like to join his email list.&nbsp;
          <a
            href=" https://nutritionfacts.org/"
            target="_blank"
            rel="noreferrer"
          >
            Nutrition Facts
          </a>
        </p>
        <p>
          FOOD REVOLUTION is an excellent online nutrition education series.
          &nbsp;
          <a
            href=" https://tinyurl.com/rmprhp65"
            target="_blank"
            rel="noreferrer"
          >
            Food revolution
          </a>
        </p>
        <p>Be well. Hope to see you soon!</p>

        <br />
      </div>
    </div>
  );
}
